import styled from 'styled-components';
import { media } from '../../../common/styles/styleUtil';

export const LeadFormWrapper = styled.div`
  background: #ffffff;
  .alert {
    width: 50%;
    margin: 0 auto;
    ${media.xs`
      width: 90%;
      padding-top: 25px
   `}
    .ant-alert-close-icon {
      color: #697684;
    }
  }
  .lead-form {
    width: 60%;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    ${media.xs`
      width: 100%;
   `}
    .text-info {
      margin: 15px 0;
      ${media.xs`
       margin:6px 0;
     `}
    }
    .message {
      width: 50%;
      padding: 0 15px;
      ${media.xs`
        width: 100%;
     `}
    }
    .details {
      width: 50%;
      padding: 0 15px;
      ${media.xs`
        width: 100%;
     `}
      .ant-form-item {
        margin-bottom: 13px;
      }

      .check-box-wrapper {
        .ant-form-item-children {
          display: flex;
          justify-content: flex-start;
        }
        .ant-form-item-control {
          line-height: 20px;
        }
        margin-top: 15px;
        .check-box-info {
          font-size: 12px;
          padding-left: 8px;
        }
      }
    }
    .submit {
      display: flex;
      flex-wrap: wrap-reverse;
      margin: 0 16px;
      ${media.xs`
        margin-top:25px;
       `}
      .submit-info {
        width: 70%;
        font-size: 12px;
        padding-right: 34px;
        ${media.xs`
          width: 100%;
          padding:24px 0 32px;
       `}
        .other-item-link {
          color: black;
          padding: 0 2px;
        }
      }
      .submit-button-wrapper {
        width: 30%;
        ${media.xs`
           width: 100%;
       `}
        .submit-button {
          width: 160px;
          height: 42px;
          color: #ffffff;
          border-radius: 3px;
          background-color: #c20014;
          ${media.xs`
            width: 100%;
            height: 46px;
         `}
        }
      }
    }
  }
`;
